const BritishColumbiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110955)">
      <path d="M0 20C0 8.95437 8.95437 0 20 0C31.0456 0 40 8.95437 40 20H0Z" fill="#F0F0F0" />
      <path d="M14.7828 18.9062L13.6895 19.9996H14.7828V18.9062Z" fill="#0052B4" />
      <path d="M25.2173 18.9062V19.9995H26.3106L25.2173 18.9062Z" fill="#0052B4" />
      <path
        d="M0.577031 15.2168C0.200859 16.7493 0 18.3508 0 19.9993H6.3107L11.0932 15.2168H0.577031Z"
        fill="#0052B4"
      />
      <path
        d="M28.9062 15.2168L33.6888 19.9993H39.9996C39.9996 18.3508 39.7987 16.7493 39.4226 15.2168H28.9062Z"
        fill="#0052B4"
      />
      <path d="M27.6767 15.2168H25.2173L29.9998 19.9993H32.4593L27.6767 15.2168Z" fill="#D80027" />
      <path
        d="M14.7827 17.6761V15.2168H14.7825L10 19.9993H12.4595L14.7827 17.6761Z"
        fill="#D80027"
      />
      <path
        d="M9.36922 3.05762C8.54484 3.57605 7.76102 4.15277 7.02344 4.78223H11.0938L9.36922 3.05762Z"
        fill="#0052B4"
      />
      <path
        d="M32.9774 4.78223C32.2398 4.1527 31.4561 3.57598 30.6318 3.05762L28.9072 4.78223H32.9774Z"
        fill="#0052B4"
      />
      <path
        d="M22.6085 12.6087H38.5889C37.8328 10.7088 36.7936 8.95266 35.5238 7.39125H22.6085H22.6085V0.169297C21.7546 0.058125 20.8839 0 19.9998 0C19.1155 0 18.245 0.058125 17.3911 0.169297V7.39117V7.39125H4.47572C3.20596 8.95266 2.16674 10.7088 1.41064 12.6087H17.391H17.391V20H22.6085V12.6087V12.6087Z"
        fill="#D80027"
      />
      <path
        d="M14.7831 4.78176V4.78168L11.768 1.7666C11.2106 2.01871 10.6673 2.29645 10.1387 2.59668L12.3237 4.78176H14.7831Z"
        fill="#D80027"
      />
      <path
        d="M25.2173 4.78258L28.2324 1.7675C27.6589 1.5082 27.0709 1.2757 26.4701 1.07031L25.2173 2.3232V4.78258Z"
        fill="#D80027"
      />
      <path d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20H40Z" fill="#F0F0F0" />
      <path
        d="M36.6663 22.5503C34.9996 22.5503 34.9996 21.0264 33.3329 21.0264C31.6663 21.0264 31.6663 22.5503 29.9997 22.5503C28.3331 22.5503 28.3331 21.0264 26.6665 21.0264C24.9999 21.0264 24.9999 22.5503 23.3331 22.5503C21.6664 22.5503 21.6663 21.0264 19.9996 21.0264C18.3329 21.0264 18.3329 22.5503 16.6663 22.5503C14.9999 22.5503 14.9999 21.0264 13.3333 21.0264C11.6665 21.0264 11.6665 22.5503 9.99971 22.5503C8.33291 22.5503 8.33291 21.0264 6.66611 21.0264C4.99971 21.0264 4.99971 22.5503 3.33307 22.5503C1.67541 22.5503 1.6658 21.0432 0.0258789 21.0271C0.0720508 21.9419 0.181269 22.84 0.346426 23.7183C1.67486 23.9136 1.79119 25.2169 3.33314 25.2169C4.99979 25.2169 4.99979 23.6932 6.66619 23.6932C8.33299 23.6932 8.33299 25.2169 9.99979 25.2169C11.6666 25.2169 11.6666 23.6932 13.3334 23.6932C15 23.6932 15 25.2169 16.6664 25.2169C18.3331 25.2169 18.3331 23.6932 19.9996 23.6932C21.6664 23.6932 21.6664 25.2169 23.3332 25.2169C25 25.2169 25 23.6932 26.6666 23.6932C28.3332 23.6932 28.3332 25.2169 29.9998 25.2169C31.6663 25.2169 31.6664 23.6932 33.333 23.6932C34.9998 23.6932 34.9998 25.2169 36.6663 25.2169C38.2085 25.2169 38.3248 23.9136 39.6533 23.7184C39.8185 22.84 39.9276 21.942 39.974 21.0271C38.3338 21.0433 38.324 22.5503 36.6663 22.5503Z"
        fill="#0052B4"
      />
      <path
        d="M33.3321 26.2451C31.6655 26.2451 31.6655 27.769 29.9989 27.769C28.3324 27.769 28.3323 26.2451 26.6657 26.2451C24.9991 26.2451 24.9991 27.769 23.3324 27.769C21.6656 27.769 21.6656 26.2451 19.9988 26.2451C18.3321 26.2451 18.3321 27.769 16.6656 27.769C14.9992 27.769 14.9992 26.2451 13.3325 26.2451C11.6657 26.2451 11.6657 27.769 9.99893 27.769C8.33213 27.769 8.33213 26.2451 6.66533 26.2451C4.99893 26.2451 4.99893 27.769 3.33229 27.769C2.14143 27.769 1.80127 26.9912 1.09619 26.5468C1.56557 27.903 2.17619 29.1931 2.91158 30.399C3.03947 30.4226 3.17869 30.4357 3.33229 30.4357C4.99893 30.4357 4.99893 28.9119 6.66533 28.9119C8.33213 28.9119 8.33213 30.4357 9.99893 30.4357C11.6657 30.4357 11.6657 28.9119 13.3325 28.9119C14.9992 28.9119 14.9992 30.4357 16.6656 30.4357C18.3322 30.4357 18.3322 28.9119 19.9988 28.9119C21.6656 28.9119 21.6656 30.4357 23.3324 30.4357C24.9992 30.4357 24.9992 28.9119 26.6657 28.9119C28.3324 28.9119 28.3324 30.4357 29.9989 30.4357C31.6655 30.4357 31.6656 28.9119 33.3321 28.9119C34.9989 28.9119 34.9989 30.4357 36.6655 30.4357C36.8192 30.4357 36.9585 30.4226 37.0863 30.3989C37.8217 29.1931 38.4324 27.903 38.9019 26.5469C38.1967 26.9911 37.8566 27.769 36.6655 27.769C34.9989 27.769 34.9989 26.2451 33.3321 26.2451Z"
        fill="#0052B4"
      />
      <path
        d="M39.9893 19.3711C39.991 19.4266 39.9929 19.4822 39.9942 19.538C39.9929 19.4823 39.9909 19.4266 39.9893 19.3711Z"
        fill="#F0F0F0"
      />
      <path
        d="M0.00634766 19.538C0.00767578 19.4823 0.00955078 19.4267 0.0112695 19.3711C0.00962891 19.4267 0.00759766 19.4823 0.00634766 19.538Z"
        fill="#F0F0F0"
      />
      <path
        d="M0 19.9996C0 19.8454 0.00234375 19.6917 0.00585938 19.5381C0.00226563 19.6917 0 19.8454 0 19.9996Z"
        fill="#F0F0F0"
      />
      <path
        d="M0 20C0 20.3643 0.0103125 20.7263 0.0297656 21.0857C1.66594 21.1041 1.6768 22.6087 3.33328 22.6087C4.99992 22.6087 4.99992 21.0849 6.66633 21.0849C8.33313 21.0849 8.33313 22.6087 9.99992 22.6087C11.6667 22.6087 11.6667 21.0849 13.3335 21.0849C15.0002 21.0849 15.0002 22.6087 16.6666 22.6087C18.3332 22.6087 18.3332 21.0849 19.9998 21.0849C21.6666 21.0849 21.6666 22.6087 23.3334 22.6087C25.0002 22.6087 25.0002 21.0849 26.6667 21.0849C28.3334 21.0849 28.3334 22.6087 29.9999 22.6087C31.6665 22.6087 31.6666 21.0849 33.3331 21.0849C34.9999 21.0849 34.9999 22.6087 36.6665 22.6087C38.3231 22.6087 38.334 21.1041 39.9705 21.0857C39.9897 20.7262 40 20.3643 40 20H0Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.9937 19.5381C39.9972 19.6915 39.9995 19.8453 39.9995 19.9996C39.9995 19.8454 39.9972 19.6917 39.9937 19.5381Z"
        fill="#F0F0F0"
      />
      <path
        d="M33.3329 31.4609C31.6663 31.4609 31.6663 32.9848 29.9997 32.9848C28.3332 32.9848 28.3331 31.4609 26.6665 31.4609C24.9999 31.4609 24.9999 32.9848 23.3332 32.9848C21.6664 32.9848 21.6664 31.4609 19.9996 31.4609C18.3329 31.4609 18.3329 32.9848 16.6664 32.9848C15 32.9848 15 31.4609 13.3333 31.4609C11.6665 31.4609 11.6665 32.9848 9.99975 32.9848C8.33295 32.9848 8.33295 31.4609 6.66615 31.4609C5.51506 31.4609 5.15889 32.1878 4.49951 32.6376C6.24865 34.7802 8.43381 36.5524 10.9186 37.8213L19.9999 37.3638L29.0812 37.8212C31.5658 36.5523 33.751 34.7803 35.5001 32.6377C34.8405 32.188 34.4843 31.4609 33.3329 31.4609Z"
        fill="#0052B4"
      />
      <path
        d="M31.0929 31.9391L25.0089 33.1028L24.2381 26.9571L20.0005 31.477L15.763 26.957L14.9919 33.1027L8.9082 31.9391L11.8917 37.365L10.9173 37.8233C13.643 39.2153 16.7299 40.0005 20.0005 40.0005C23.271 40.0005 26.358 39.2153 29.0836 37.8234L28.1096 37.3652L31.0929 31.9391Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110955">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BritishColumbiaSvg;
